import React from 'react'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
/* REDUX */
import { connect } from 'react-redux'
import { registerUser, updateUser } from '../../actions/auth'
import { Field, reduxForm } from 'redux-form'
/* FIREBASE */
import b64toBlob from 'b64-to-blob'
import * as firebase from 'firebase'
import 'react-quill/dist/quill.snow.css'

const form = reduxForm({
	form: 'register',
})

class RegisterForm extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			step: 1,
			error: ''
		}
		this.nextStep = this.nextStep.bind(this)
		this.prevStep = this.prevStep.bind(this)
		this.renderError = this.renderError.bind(this)
		this.handleFormSubmit = this.handleFormSubmit.bind(this)
		this.handleFirebase = this.handleFirebase.bind(this)
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			error: ''
		})
	}
	
	renderError(error) {
		this.setState({
			error: error
		})
	}
	
	handleFormSubmit() {
		const formProps = this.props.formValues
		if (document.getElementById("uploadedImage").src) {
			this.props.registerUser(formProps, this.callFirebaseAPI)
		} else {
			this.props.registerUser(formProps)
		}
	}
	
	nextStep() {
		if ( this.state.step < 3) {
			this.setState({
				step: this.state.step + 1
			})
		}
	}
	
	prevStep() {
		if ( this.state.step > 0) {
			this.setState({
				step: this.state.step - 1
			})
		}
	}
	
	handleFirebase(downloadURL) {
		const formProps = this.props.formValues
		const newProps = {
			...formProps,
			profile_picture: downloadURL
		}
		this.props.updateUser(newProps)
	}
	
	callFirebaseAPI = (user_id) => {
		const imageURI = document.getElementById("uploadedImage").src
		var data = b64toBlob(imageURI.split(',')[1], 'image/jpeg')
		this.uploadFirebase(user_id, data, this.handleFirebase)
	}
	
	uploadFirebase = (user_id, data, callback) => {
		let file = data;
	    let storageRef = firebase.storage().ref()
	    let uploadTask = storageRef.child('users/' + user_id + '.jpg').put(file);
	    uploadTask.on('state_changed', function(snapshot){
			var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			console.log('Upload is ' + progress + '% done');
		}, function(error) {
			console.log(error);
		}, function() {
			var downloadURL = uploadTask.snapshot.downloadURL;
			callback(downloadURL)
		});
	}
	
	render() {
		
		const { handleSubmit, switchAuth, formValues } = this.props
		
		let renderStep
		switch(this.state.step) {
			case 1:
				renderStep = <StepOne nextStep={ this.nextStep } {...formValues} renderError={ this.renderError } />
				break
			case 2:
				renderStep = <StepTwo nextStep={ this.nextStep } prevStep={ this.prevStep } {...formValues} renderError={ this.renderError } />
				break
			case 3:
				renderStep = <StepThree prevStep={ this.prevStep } {...formValues} handleFormSubmit={ this.handleFormSubmit } />
				break
			default:
				renderStep = <StepOne nextStep={ this.nextStep } {...formValues} />
		}
		
		return (
			<form>
				<h4 className="title">Sign up</h4>
				<div className="command-wrapper">
					<span className="welcome">Existing user?</span>
					<span className="action">
						<a className="modal-link" onClick={ switchAuth }>Sign in</a>
					</span>
				</div>
				<p className="median">Step { this.state.step } of 3</p>
				<span className="error">{ this.state.error }</span>
				<span className="success"></span>
				{ renderStep }
			</form>
		)
	}
}

const mapStateToProps = (state) => {
	const formState = state.form.register || {}
	const formValues = formState.values
	return {
		formValues
	}
}

export default connect(mapStateToProps, {registerUser, updateUser})(form(RegisterForm))


// WEBPACK FOOTER //
// ./src/components/Modals/RegisterForm.js